/* 
 * Copyright (C) Patient10x (https://www.patient10x.com) - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import { createSlice } from "@reduxjs/toolkit";

import { AsyncState } from "common/utils/async-state";

import { ExImage } from "./media.entities";


export const MediaStore = createSlice({
  name: "media",
  initialState: {
    uploadExImage: {} as AsyncState<ExImage>,
    updateExImage: {} as AsyncState<ExImage>,
  },
  reducers: {
    UpdateUploadExImageState: (state, action) => {
      state.uploadExImage = action.payload;
    },
    NextUpdateExImageState: (state, action) => {
      state.uploadExImage = action.payload;
    },
  },
});

export const {
  UpdateUploadExImageState,
  NextUpdateExImageState,
} = MediaStore.actions;

export type MediaState = ReturnType<typeof MediaStore.getInitialState>

export const { reducer: mediaReducer } = MediaStore;